<template>
  <div class="right-nav">
    <ul>
      <li class="right-nav-item">
        <div class="right-nav-item-content" @click="top()">
          <img src="../../../static/img/formIcons/backTopB.png" style="margin-left:-3px;margin-top:-2px;" alt="">
          <span>返回顶部</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    goHome() {
      this.$router.push({ path: '/home' });
    },
    top() {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.top);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
ul {
  list-style: none;
}

ul li {
  width: 40px;
  height: 50px;
  text-align: center;
  padding: 8px 3px;
  color: #fff;
  cursor: pointer;

  img {
    display: block;
  }

  span {
    display: none;
  }
}

ul li :hover {
  background-color: #409EFF;
  color: $color-main;
  border-color: #409EFF;

  img {
    display: none;
  }

  span {
    display: block;
  }
}

.iconshezhi:before {
  content: '\e605';
  color: #fff;
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/common/area/right-nav.vue